@if (inputConfig.typeInHTML !== InputHTMLTypes.DATE) {
    <mat-form-field class="w-full">
        <mat-label>
            <apcam-translation [model]="inputConfig.label" />
        </mat-label>
        <input
            matInput
            [readonly]="disabled"
            [formControlName]="formcontrolName"
            [type]="inputConfig.typeInHTML"
            [placeholder]="placeholderText"
            [required]="inputConfig.required" />
        @if (input.hasError('required')) {
            <mat-error>
                {{ 'shared.validation.required' | translate }}
            </mat-error>
        } @else if (input.hasError('email')) {
            <mat-error>
                {{ 'shared.validation.email' | translate }}
            </mat-error>
        } @else if (input.hasError('minlength')) {
            <mat-error>
                {{
                    'shared.validation.minChars'
                        | translate
                            : {
                                  min: input.getError('minlength')
                                      .requiredLength,
                              }
                }}
            </mat-error>
        } @else if (input.hasError('maxlength')) {
            <mat-error>
                {{
                    'shared.validation.maxChars'
                        | translate
                            : {
                                  max: input.getError('maxlength')
                                      .requiredLength,
                              }
                }}
            </mat-error>
        } @else if (input.hasError('min')) {
            <mat-error>
                {{
                    'shared.validation.minNumber'
                        | translate: { min: input.getError('min').min }
                }}
            </mat-error>
        } @else if (input.hasError('max')) {
            <mat-error>
                {{
                    'shared.validation.maxNumber'
                        | translate: { max: input.getError('max').max }
                }}
            </mat-error>
        }
    </mat-form-field>
} @else {
    <mat-form-field class="w-full">
        <mat-label>
            <apcam-translation [model]="inputConfig.label" />
        </mat-label>
        <input
            [matDatepicker]="picker"
            matInput
            [formControlName]="formcontrolName"
            [placeholder]="placeholderText"
            [min]="inputConfig.min"
            [max]="inputConfig.max"
            [required]="inputConfig.required" />
        <mat-datepicker-toggle matIconSuffix [for]="picker" />
        <mat-datepicker #picker />
        @if (input.hasError('required')) {
            <mat-error>
                {{ 'shared.validation.required' | translate }}
            </mat-error>
        } @else if (input.hasError('minDate')) {
            <mat-error>
                {{
                    'shared.validation.minDate'
                        | translate: { min: input.getError('minDate').value }
                }}
            </mat-error>
        } @else if (input.hasError('maxDate')) {
            <mat-error>
                {{
                    'shared.validation.maxDate'
                        | translate: { max: input.getError('maxDate').value }
                }}
            </mat-error>
        }
    </mat-form-field>
}
